"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = exports.fromEntries = exports.applySpec = exports.objectKeys = exports.filterUndefined = exports.objectFilter = exports.pick = exports.omit = void 0;
/*
 * Returns a new object omitting the keys specified.
 * @param keys - the keys to omit
 * @param object - the object to omit from
 */
function omit(keys, object) {
    const result = {};
    Object.keys(object).forEach(key => {
        if (keys.includes(key))
            return;
        result[key] = object[key];
    });
    return result;
}
exports.omit = omit;
function pick(keys, object) {
    const result = {};
    keys.forEach(key => {
        if (key in object) {
            result[key] = object[key];
        }
    });
    return result;
}
exports.pick = pick;
/**
 * Returns the items of an object that meet the condition specified in a callback function.
 *
 * @param object the object to loop through
 * @param fn The filter function
 */
function objectFilter(object, fn) {
    const result = {};
    Object.keys(object).forEach(key => {
        const value = object[key];
        const shouldPass = fn(value, key, object);
        if (shouldPass) {
            result[key] = value;
        }
    });
    return result;
}
exports.objectFilter = objectFilter;
const filterUndefined = (object) => objectFilter(object, val => val !== null && val !== undefined);
exports.filterUndefined = filterUndefined;
const objectKeys = (obj) => Object.keys(obj);
exports.objectKeys = objectKeys;
// applySpec :: Object -> a -> Object
const applySpec = (obj) => (...args) => (0, exports.objectKeys)(obj).reduce((acc, key) => {
    acc[key] = obj[key](...args);
    return acc;
}, {});
exports.applySpec = applySpec;
/**
 * Object.entries polyfill for Node v10 compatibility
 */
const fromEntries = (entries) => entries.reduce((carry, [key, value]) => {
    carry[key] = value;
    return carry;
}, {});
exports.fromEntries = fromEntries;
/**
 * Get value from a deeply nested object using a string path.
 * Memorizes the value.
 * @param obj - the object
 * @param path - the string path
 * @param fallback  - the fallback value
 */
function get(path, obj, fallback, index) {
    const key = typeof path === 'string' ? path.split('.') : [path];
    for (index = 0; index < key.length; index += 1) {
        if (!obj)
            break;
        obj = obj[key[index]];
    }
    return obj === undefined ? fallback : obj;
}
exports.get = get;
//# sourceMappingURL=object.js.map